
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/full-stack-workshop-series-vol-1",
      function () {
        return require("private-next-pages/full-stack-workshop-series-vol-1.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/full-stack-workshop-series-vol-1"])
      });
    }
  